import {Events} from 'backbone';

/**
 * Register a backbone event and return a function to unregister it.
 * @param thing Backbone collection/model/view/dispatcher (anything that extends `Backbone.Events`)
 * @param event Event name
 * @param cb Event callback
 * @returns Function to unregister the event
 *
 * @example
 * ```ts
 * const unregister = registerBackboneEvent(collection, 'add', (model) => {...});
 * unregister();
 * ```
 */
export const registerBackboneEvent = <T extends Events = Events>(
	thing: T,
	event: string,
	cb: (...args: any) => void,
) => {
	thing.on(event, cb);
	return () => thing.off(event, cb);
};

export default registerBackboneEvent;
